//import {galleryData,galleryChildren} from "../store/GalleryData"
module.exports = {
   // gallery:galleryData,
   //  children:galleryChildren,
};


// WEBPACK FOOTER //
// ./src/default/data.js